module.exports = {"data":{"allMarkdownRemark":null},"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/blog.json
// module id = 437
// module chunks = 49683490770531